import React, { Component } from "react";
import { signIn, fetchUserAttributes, updateUserAttributes } from "aws-amplify/auth";
import GoogleButton from "../components/GoogleButton";
import { FormGroup, FormControl, ControlLabel, HelpBlock } from "react-bootstrap";
import { Link } from "react-router-dom";
import LoaderButton from "../components/LoaderButton";
import ls from 'local-storage';
import "./Login.css";
import ConfirmationCode from "../components/ConfirmationCode";

export default class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      loginErrorMessage: "",
      socialErrorMessage: "",
      showConfirmation: false
    };
  }

  validateForm() {
    return this.state.email.length > 0 && this.state.password.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSocialError = async (error) => {
    this.setState({ socialErrorMessage: error})
  };

  handleSubmit = async event => {
    event.preventDefault();

    this.setState({ isLoading: true });

    try {
      await signIn({
        username: this.state.email,
        password: this.state.password
      });
      const attrs = await fetchUserAttributes();

      if (attrs["custom:city_id"] && attrs.address) {
        try {
          // Users might have legacy `address` data (string), delete it to force a reset later if found.
          JSON.parse(attrs.address);
          ls.set("location", JSON.parse(attrs.address));
        } catch (e) {
          await updateUserAttributes({
            userAttributes: {
            "address": "",
            "custom:city_id": ""
            }
          });
        }
        ls.set("location_id", attrs["custom:city_id"]);
        this.props.userHasAuthenticated(true);
      } else {
        if (ls.get("location")) {
          await updateUserAttributes({
            userAttributes: {
              "address": JSON.stringify(ls.get("location")),
              "custom:city_id": ls.get("location_id")
            }
            });
          this.props.userHasAuthenticated(true);
        } else {
          this.props.userHasAuthenticated(true);
        }
      }
    } catch (e) {
      if (e.code === "UserNotConfirmedException") {
        this.setState({ showConfirmation: true});
      }
      this.setState({ loginErrorMessage: e.message });
      this.setState({ isLoading: false });
    }
  }

  renderLogin() {
    return (
    <form onSubmit={this.handleSubmit}>
          <FormGroup controlId="email" bsSize="large">
            <ControlLabel>Email</ControlLabel>
            <FormControl
              type="email"
              value={this.state.email}
              onChange={this.handleChange}
            />
          </FormGroup>
          <FormGroup controlId="password" bsSize="large">
            <ControlLabel>Password</ControlLabel>
            <FormControl
              value={this.state.password}
              onChange={this.handleChange}
              type="password"
            />
          </FormGroup>
          <Link className="forgot-password" to="/login/reset">Forgot password?</Link>
          <LoaderButton
            block
            bsSize="large"
            disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text="Login"
            loadingText="Logging in..."
          />
          {this.state.loginErrorMessage &&
          <HelpBlock>{this.state.loginErrorMessage}</HelpBlock>
          }
          <hr />
          <GoogleButton
            onError={this.handleSocialError}
          />
          
          {/* Comment out for now <GithubButton /> */}
          {this.state.socialErrorMessage &&
          <HelpBlock>Please try again.</HelpBlock>
          }
          <br />
          <h4 style={{textAlign: "center"}}>Not a member? <Link to="/signup"><b>Sign up</b></Link>.</h4>
        </form>
        );
      }

confirmSuccess = async event => {
  this.props.userHasAuthenticated(true);
  this.props.history.push("/");      
}

  renderConfirmation() {
    return (
      <ConfirmationCode email={this.state.email} password={this.state.password} confirmSuccess={this.confirmSuccess} />
    );
  }

  render() {
    return (
      <div className="Login">
      {this.state.showConfirmation
          ? this.renderConfirmation()
          : this.renderLogin()}
        
      </div>
    );
  }
}
